export default {
  youtube: {
    color: '#fff',
    background: '#ff0000',
    hoverColor: '#fff',
    hoverBackground: '#b70a0a',
    activeColor: '#fff',
    activeBackground: '#b70a0a',
  },
  facebook: {
    color: '#fff',
    background: '#3b5998',
    hoverColor: '#fff',
    hoverBackground: '#272580',
    activeColor: '#fff',
    activeBackground: '#272580',
  },
  twitter: {
    color: '#fff',
    background: '#1da1f2',
    hoverColor: '#fff',
    hoverBackground: '#2651b7',
    activeColor: '#fff',
    activeBackground: '#2651b7',
  },
  vk: {
    color: '#fff',
    background: '#4a76a8',
    hoverColor: '#fff',
    hoverBackground: '#498dda',
    activeColor: '#fff',
    activeBackground: '#498dda',
  },
  telegram: {
    color: '#fff',
    background: '#0088cc',
    hoverColor: '#fff',
    hoverBackground: '#14588a',
    activeColor: '#fff',
    activeBackground: '#14588a',
  },
};
